import styled from 'styled-components';

export const Frame = styled.div`
  height: 480px;
  border-radius: 8px;

  .map-loading {
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
  }

  .map-label {
    width: max-content;
    background: ${(props) => props.theme.$blue800};

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -6px;
      transform: translateX(-50%);
      border: 6px solid transparent;
      border-bottom: 0;
      border-top-color: ${(props) => props.theme.$blue800};
    }
  }

  .map-label-item {
    background: ${(props) => props.theme.$blue800};
    font-size: 14px;
    font-weight: 500;
    padding: 0.5rem 0.75rem;

    & + .map-label-item {
      border-top: 1px solid rgba(255, 255, 255, 0.2) !important;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;
